import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import CategoryStoreActions from '../flux/CategoryStoreActions';
import TimelessStore from '../flux/TimelessStore';
import Card from '../components/Card';
import __ from '../utils/translator';
import PatternCardList from '../components/PatternCardList';
import PageHeader from '../components/PageHeader';
import CardTitle from '../components/CardTitle';
import CardProgress from '../components/CardProgress';
import remToPixels from '../utils/remToPixels';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import PageTitle from '../components/PageTitle';
import RenderOnMobile from "../components/responsive/RenderOnMobile";
import RenderOnTablet from "../components/responsive/RenderOnTablet";
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import Header from '../components/organisms/Header';

function resizeCover(cover) {
  return thronThumbnailResize(cover, {
    width: remToPixels(45),
    height: remToPixels(45)
  });
}

function sort(categories) {
  return categories.slice().sort((category1, category2) => category1.sorting - category2.sorting);
}

class Timeless extends Component {
  state = {
    categories: [],
  };

  subscriptions = [];

  componentDidMount() {
    CategoryStoreActions.fetch();

    this.subscriptions.push(TimelessStore.addListener(() => {
      this.setState({ categories: sort(TimelessStore.getState()) });
    }));
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header />

        <PageTitle withTracking title="Timeless" />

        <RenderOnTablet>
          <PageHeader
            crumbs={[__('Home'), __('Timeless')]}
            title={__('Timeless')} />
        </RenderOnTablet>

        <Container>
          <PatternCardList>
            {this.state.categories.map(category => (
              <Card
                key={category.id}
                // style={{ border: '.25rem solid transparent' }}
                linkTo={`/timeless/${category.id}`}
                cover={resizeCover(TimelessStore.getRandomCover(category))}
                justifyContent="flex-end"
              >
                <CardTitle
                  small={themeResponsiveProperty(false, true)(this.props)}
                  style={{ textTransform: 'uppercase', }}>
                  {category.name}
                </CardTitle>

                <CardProgress percentage={category.percentage} />
              </Card>
            ))}
          </PatternCardList>
        </Container>
      </div>
    );
  }
}

export default withTheme(Timeless);

const Container = styled.div`
  ${props => props.theme.isTablet && css`
    background-color: ${props.theme.primaryBackgroundColorNegative};
  `}
`;
